import {
  FETCH_RELEASE_NOTES_STARTED,
  FETCH_RELEASE_NOTES_SUCCESS,
  FETCH_RELEASE_NOTES_FAILIED,
} from './types';

import {
  fetchReleaseNotes as fetchReleaseNotesApi,
} from '../api';

import { fetchingError } from '../../../../../shared/store/actions';
import { errorNotification } from '../../../../../shared/store/notificationActions';

export const fetchReleaseNotes = () => async dispatch => {
  try {
    dispatch({
      type: FETCH_RELEASE_NOTES_STARTED,
    });
    const releaseNotes = await fetchReleaseNotesApi();
    dispatch({
      type: FETCH_RELEASE_NOTES_SUCCESS,
      releaseNotes,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: FETCH_RELEASE_NOTES_FAILIED,
      });
      return;
    }
    throw error;
  }
};
